// ─── Главная функция: сборка строк таблицы ────────────────────────────────────

/**
 * Сформировать строки таблицы «Комплектующие заказа с остатками»
 * Бэкенд (EquipmentsService.js) уже вернул массив со всеми правильными названиями, ед. измерения и количеством.
 * Нам нужно только найти соответствующие остатки на складе.
 * 
 * @param {object} rawOrder — документы заявок (из контекста)
 * @param {object[]} warehouseStock — список остатков со склада
 * @returns {{ key, group, label, required, unit, inStock }}[]
 */
export function buildMaterialsTable(rawOrder, warehouseStock) {
  if (!rawOrder || !rawOrder.accessories) return [];

  const accessories = rawOrder.accessories;

  return accessories.map((item, i) => {
    // backend теперь напрямую формирует name включая цвет (например: "Короб 57 чёрный", "Дверные ручки Space чёрный")
    const searchName = item.name;

    // Ищем на складе точное совпадение по materialName (без учета регистра)
    const stockRecord = warehouseStock.find(
      (s) => s.materialName?.toLowerCase() === searchName.toLowerCase()
    );

    const required = Math.round(item.count || 0);
    const inStock = stockRecord?.inStock || 0;

    return {
      key: i,
      group: item.group || "Комплектующие", // "Материалы для дверей" или "Комплектующие"
      label: item.name,
      materialName: item.name,
      required: required,
      unit: item.unit || "шт.",
      inStock: inStock,
      stockId: stockRecord?._id || null,
    };
  });
}
